import { IconButton } from "@chakra-ui/react"

import { SearchIcon } from "@/components/Icons"

type Props = { ariaLabel: string }

// 40px square, aligned with the compact search field.
export const SearchButton: React.FC<Props> = ({ ariaLabel }) => (
  <IconButton
    aria-label={ariaLabel}
    size="sm"
    boxSize="controlHSm"
    minW="controlHSm"
    minH="controlHSm"
    px="0"
    type="submit"
    flexShrink="0"
  >
    <SearchIcon boxSize="4" />
  </IconButton>
)
